import Breadcrumb from "components/Common/Breadcrumb"
import FullPageLoader from "components/fullPageLoader"
import useFetchKycData from "hooks/useFetchKycData"
import React, { useEffect } from "react"
import {
  Card,
  Col,
  Row,
  CardBody,
  CardTitle,
  Label,
  Input,
  Container,
} from "reactstrap"

const AuthorisedSignatoryDetails = () => {
  const { kycData, isLoading, user, navigate } = useFetchKycData()

  useEffect(() => {
    if (user.entity_type !== "COMPANY") {
      navigate("/dashboard")
    }
  }, [user])

  return (
    <div className="page-content">
      <Container fluid>
        {isLoading && <FullPageLoader />}
        <Breadcrumb title={"Authorised Person"} />
        {!isLoading && user?.status === "APPROVED" && kycData && (
          <div>
            <Card>
              <CardBody>
                <Row>
                  <Col xl={12}>
                    <Row className="mb-2">
                      <Col xl={6}>
                        <Label className="col-form-label">Name</Label>
                        <Input
                          disabled
                          name="name"
                          type="text"
                          className="form-control"
                          value={kycData?.investorsAadhaar?.name}
                        />
                      </Col>
                      <Col xl={6}>
                        <Label className="col-form-label">Date of Birth</Label>
                        <Input
                          disabled
                          name="dob"
                          type="text"
                          className="form-control"
                          value={kycData?.investorsAadhaar?.dob}
                        />
                      </Col>
                      <Col xl={6}>
                        <Label className="col-form-label">PAN</Label>
                        <Input
                          disabled
                          name="pan"
                          type="text"
                          className="form-control"
                          value={kycData?.investorsPAN?.pan}
                        />
                      </Col>
                      <Col xl={6}>
                        <Label className="col-form-label">Aadhaar No.</Label>
                        <Input
                          disabled
                          name="aadhaar_no"
                          type="text"
                          className="form-control"
                          value={kycData?.investorsAadhaar?.aadhaar_no}
                        />
                      </Col>
                      <Col xl={6}>
                        <Label className="col-form-label">Designation</Label>
                        <Input
                          disabled
                          name="designation"
                          type="text"
                          className="form-control"
                          value={
                            kycData?.businessAdditionalDetails?.designation
                          }
                        />
                      </Col>
                      <Col xl={6}>
                        <Label className="col-form-label">
                          {kycData?.businessAdditionalDetails
                            ?.constitution_of_business ===
                          "Limited Liability Partnership"
                            ? "DPIN"
                            : "DIN"}
                        </Label>
                        <Input
                          disabled
                          name="dpin"
                          type="text"
                          className="form-control"
                          value={
                            kycData?.businessAdditionalDetails?.dpin ??
                            "Not Applicable"
                          }
                        />
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </div>
        )}
      </Container>
    </div>
  )
}

export default AuthorisedSignatoryDetails
